import * as React from 'react';

import {useMutation} from '@apollo/react-hooks';
import moment from 'moment';

import type {CampaignType} from 'nutshell-graphql-types';
import type {
    EditionFragment as Edition,
    ScheduleEdition as ScheduleEditionMutation,
    ScheduleEditionVariables as ScheduleEditionMutationVariables,
    UnscheduleEdition as UnscheduleEditionMutation,
    UnscheduleEditionVariables as UnscheduleEditionMutationVariables,
} from 'nutshell-graphql-types';

import SCHEDULE_EMAIL_EDITION from './graphql/mutations/schedule-email-marketing-edition.graphql';
import UNSCHEDULE_EMAIL_EDITION from './graphql/mutations/unschedule-email-marketing-edition.graphql';
import {RescheduleEditionModal} from './reschedule-edition-modal';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    edition: Edition;
    type: CampaignType;
};

export function RescheduleModal(props: Props) {
    const [scheduleEdition] = useMutation<
        ScheduleEditionMutation,
        ScheduleEditionMutationVariables
    >(SCHEDULE_EMAIL_EDITION);

    const [unscheduleEdition] = useMutation<
        UnscheduleEditionMutation,
        UnscheduleEditionMutationVariables
    >(UNSCHEDULE_EMAIL_EDITION);

    return (
        <RescheduleEditionModal
            isOpen={props.isOpen}
            onClose={props.onClose}
            type={props.type}
            scheduledTime={props.edition.scheduledTime}
            onSchedule={(scheduledTime: moment.Moment) => {
                return scheduleEdition({
                    variables: {
                        edition: {
                            editionId: props.edition.id,
                            scheduledTime: scheduledTime.unix(),
                        },
                    },
                });
            }}
            onUnschedule={() => {
                return unscheduleEdition({
                    variables: {
                        edition: {
                            editionId: props.edition.id,
                        },
                    },
                });
            }}
        />
    );
}
